import React, {useState, useEffect } from 'react'
import {
  Badge,
  Box,
  Drawer,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import ProjectCount from '../../../components/common/projectCount/ProjectCount';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getProjectCounts } from '../../../modules/auth';

// 5분마다 재조회 - 매 렌더마다 부르면 안 되니 interval 로만 건드린다.
const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

const ProjectCounterContainer = ({ compact = false }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [prjCounts, setprjCounts] = useState([]);
  const [open, setOpen] = useState(false);
  const { projectCounts } = useSelector(({ auth }) => ({
    projectCounts: auth.projectCounts,
  }));

  // 라우트가 바뀔 때 다시 조회 (예: 작업지원을 처리하고 다른 화면으로 돌아왔을 때 뱃지가 갱신되게)
  useEffect(() => {
    dispatch(getProjectCounts());
  }, [dispatch, location.pathname]);

  // + 5분 주기 재조회
  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(getProjectCounts());
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [dispatch]);

  useEffect(() => {
    if(projectCounts){
      setprjCounts(projectCounts)
    }
  }, [projectCounts])

  // 모바일 아이콘의 뱃지 숫자는 "해야 할 일" 총합이라 지연(overdue)도 더한다.
  const totalCount = prjCounts.reduce(
    (sum, item) => sum + Number(item?.count || 0) + Number(item?.overdue || 0),
    0,
  );

  if (compact) {
    return (
      <>
        <Tooltip title="업무 카운트">
          <IconButton color="inherit" size="small" onClick={() => setOpen(true)}>
            <Badge
              color="secondary"
              badgeContent={totalCount}
              invisible={!totalCount}
              max={99}
            >
              <DonutSmallIcon />
            </Badge>
          </IconButton>
        </Tooltip>

        <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)}>
          <Box sx={{ width: '100vw', maxWidth: '100vw', p: 2 }}>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ mb: 1.5 }}
            >
              <DonutSmallIcon color="primary" />
              <Typography variant="h6" fontWeight={700} sx={{ flex: 1 }}>
                업무 카운트
              </Typography>
              <IconButton size="small" onClick={() => setOpen(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Stack>

            <Stack spacing={1}>
              {prjCounts.map((prj, index) => (
                <ProjectCount
                  project={prj}
                  key={prj.id || index}
                  fullWidth
                  onSelect={() => setOpen(false)}
                />
              ))}
            </Stack>
          </Box>
        </Drawer>
      </>
    );
  }

  return (
    <Box sx={{display:'flex', justifyContent:'flex-start', alignItems:'center'}}>
      {prjCounts.map((prj, index)=>(
        <ProjectCount project={prj} key={prj.id || index}/>
      ))}
    </Box>
  )
}

export default ProjectCounterContainer
